import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {BlogIndexPage} from '../models';
import {BlogState} from '../state/blog.state';
import {LoadIndex, LoadSubscription} from '../state/blog.actions';
import {GetStartedService} from '../../../layout/header/get-started.service';
import {FADE_IN} from '../../../shared/animations';
import { GeneralHeaderComponent } from '../../../layout/header/components/general-header/general-header.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { RtLoadingComponent } from '../../../rt-loading/rt-loading/rt-loading.component';
import { BlogNewsletterComponent } from '../blog-newsletter/blog-newsletter.component';
import { ExploreYourBrainComponent } from '../../../shared/components/explore-your-brain/explore-your-brain.component';
import { FooterComponent } from '../../../layout/footer/footer.component';
import { AsyncPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-blog-root',
    templateUrl: './blog-root.component.html',
    styleUrls: ['./blog-root.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN],
    imports: [GeneralHeaderComponent, MatProgressSpinner, RouterLink, RtLoadingComponent, BlogNewsletterComponent, ExploreYourBrainComponent, FooterComponent, AsyncPipe, DatePipe]
})
export class BlogRootComponent implements OnInit {
  public readonly page$ = this.store.select(BlogState.index);
  public readonly loading$ = this.store.select(BlogState.loading);

  /** Emits current page with limited items. */
  public pageLimitedItems$: Observable<BlogIndexPage>;

  /** Initial limit of posts to show on page. */
  public readonly initPostsLimit = 6;

  /** Emits current news limit on each limit update. */
  public postsShowLimit$ = new BehaviorSubject(this.initPostsLimit);

  constructor(private store: Store, public gs: GetStartedService) {}

  ngOnInit() {
    this.store.dispatch([new LoadIndex(), new LoadSubscription()]);

    // Keep some limit of post as recent; update on each limit change.
    // Should be removed once the limit may be set in API request.
    this.pageLimitedItems$ = combineLatest([this.page$, this.postsShowLimit$.asObservable()]).pipe(
      filter(([page, _]) => !!page),
      map(([page, limit]) => {
        if (page?.items?.length > limit) {
          return {
            ...page,
            items: page.items.slice(0, limit),
          };
        } else {
          return page;
        }
      })
    );
  }

  /**
   * Increase the limit of news on the page.
   */
  public showMorePosts(): void {
    this.postsShowLimit$.next(this.postsShowLimit$.value + 3);
  }
}
